import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { nameof } from 'ts-simple-nameof';
import { DialogService } from '../../dialog/dialog.service';
import { DialogSubscriptionComponent } from '../../dialog/dialog-subscription.component';
import { TableStateService } from '../../tables/table-state.service';
import {
    ActionButtonClickEvent,
    ActionComplete,
    ColumnDefinition,
    TableSearchCriteria
} from '../../tables/table.types';
import { TextEditComponent } from '../text-edit/text-edit.component';
import { ComponentText, TextService } from '../text.service';

@Component({
    selector: 'app-text-list',
    templateUrl: './text-list.component.html',
    styleUrls: ['./text-list.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class TextListComponent extends DialogSubscriptionComponent implements OnInit {
    @Input() formConfigurationAlias: string;
    @Input() enableAddButton: boolean = true;
    tableName: string = 'text_list';
    baseUrl: string = 'componentText';
    searchCriteria: TableSearchCriteria;
    columns: Array<ColumnDefinition> = [
        {
            property: nameof<ComponentText>((m) => m.id)
        },
        {
            property: nameof<ComponentText>((m) => m.alias)
        },
        {
            property: nameof<ComponentText>((m) => m.formConfigurationAlias)
        },
        {
            property: 'actions',
            actions: [
                {
                    discriminator: 'edit',
                    icon: 'edit',
                    clickCallBack: {
                        function: this.show,
                        this: this
                    }
                },
                {
                    discriminator: 'delete',
                    icon: 'delete',
                    clickCallBack: {
                        observable: (event: ActionButtonClickEvent<ComponentText>) => {
                            return this.textService.delete(event.element.id);
                        },
                        function: (event: ActionButtonClickEvent<any>) => {
                            this.tableService.sendToTable({
                                tableName: this.tableName,
                                element: event.element,
                                remove: true
                            });
                            return {
                                completed: true
                            };
                        },
                        this: this
                    }
                }
            ]
        }
    ];

    constructor(
        private dialogService: DialogService<ComponentText>,
        private tableService: TableStateService,
        private textService: TextService
    ) {
        super();
    }

    ngOnInit(): void {
        this.searchCriteria = {
            formConfigurationAlias: this.formConfigurationAlias
        };
    }

    show($event?: ActionButtonClickEvent<ComponentText>): ActionComplete {
        let text = $event?.element;
        if (!text) {
            text = {
                id: -1,
                text: '',
                formConfigurationAlias: this.formConfigurationAlias,
                isNew: true,
                mayEdit: true
            };
        }
        const dialog = this.dialogService.show(text, {
            uniqueId: this.dialogService.generateUniqueId(
                text,
                nameof<ComponentText>((m) => m.id),
                'TextEditComponent'
            ),
            dialogAlias: 'TextEditComponent',
            title: `${text.formConfigurationAlias}: ${text.alias}`,
            component: TextEditComponent
        });
        this.addSubscription(
            this.dialogService.response.subscribe((next) => {
                if (next.dialogAlias === 'TextEditComponent') {
                    this.tableService.sendToTable({
                        tableName: this.tableName,
                        element: next.payload,
                        update: true
                    });
                }
            }),
            dialog
        );
        return {
            completed: true
        };
    }
}
